import { PrimariaApi } from "@uxland/primary-shell";
import { LitElement, css, html, unsafeCSS } from "lit";
import { customElement } from "lit/decorators.js";
import { lazyInject } from "../../../../infrastructure/ioc/container";
import { TYPES } from "../../../../infrastructure/ioc/types";
import { connectedProperty } from "../../../../infrastructure/state/connected-property";
import styles from "./styles.css?inline";
import { template } from "./template";

import { customFilterGroupsWithOptionsSelector } from "../../../selectors";
import { activityHistoryEnabledCommonFiltersSelector } from "../../common-filters/selectors";
import { SetCommonFilter } from "../../common-filters/set-common-filter/request";
import { SetCustomFilterValue } from "../../custom-filters/set-custom-filter-value/request";
import { DeleteDiagnosticFilterValueCommand } from "../../diagnostic-filters/delete/request";
import { diagnosticFilterSelector } from "../../diagnostic-filters/selectors";
import {
  IActivityHistoryCustomFilterGroup,
  IActivityHistoryDiagnosticsFilter,
  IActivityHistoryFilter,
  IActivityHistoryUpFilter,
} from "../../model";
import { ResetFiltersCommand } from "../../reset/request";
import { upFilterSelector } from "../../up-filters/selectors";
import { SetUpFiltersCommand } from "../../up-filters/set/request";

//@ts-ignore
@customElement("active-filters-badges")
export class ActiveFiltersBadges extends LitElement {
  render() {
    return html`${template(this)}`;
  }

  static styles = css`
    ${unsafeCSS(styles)}
  `;

  @lazyInject(TYPES.primaryApi)
  api: PrimariaApi;

  activityHistoryCommonFiltersSelector;

  @connectedProperty(activityHistoryEnabledCommonFiltersSelector)
  enabledCommonFilters: IActivityHistoryFilter[];

  @connectedProperty(customFilterGroupsWithOptionsSelector)
  enabledFilters: IActivityHistoryCustomFilterGroup[];

  @connectedProperty(diagnosticFilterSelector)
  diagnosticFilterEnabled: IActivityHistoryDiagnosticsFilter;

  @connectedProperty(upFilterSelector)
  upFilterEnabled: IActivityHistoryUpFilter;

  _onDeleteFilterValue(filterGroupId: string, filterId: string, optionId: string, value: boolean) {
    this.api.broker.send(
      new SetCustomFilterValue({
        filterGroupId,
        filterId,
        optionId,
        enabled: value,
      }),
    );
  }

  _onDeleteCommonFilterValue(filterId: string) {
    this.api.broker.send(new SetCommonFilter({ id: filterId, enabled: false }));
  }

  _onDeleteDiagnosticFilterValue(diagnosticCodi: string) {
    this.api.broker.send(new DeleteDiagnosticFilterValueCommand({ diagnosticCodi }));
  }

  _onDeleteUpFilterValue(upValue: string) {
    this.api.broker.send(new SetUpFiltersCommand([...this.upFilterEnabled.enabledValues.filter((v) => v !== upValue)]));
  }

  resetFilters() {
    this.api.broker.send(new ResetFiltersCommand());
  }
}
